import { render, staticRenderFns } from "./SaleEditRowExtraInfoFieldsSettings.vue?vue&type=template&id=5ffd0e9e&scoped=true"
import script from "./SaleEditRowExtraInfoFieldsSettings.vue?vue&type=script&lang=ts"
export * from "./SaleEditRowExtraInfoFieldsSettings.vue?vue&type=script&lang=ts"
import style0 from "./SaleEditRowExtraInfoFieldsSettings.vue?vue&type=style&index=0&id=5ffd0e9e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd0e9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ffd0e9e')) {
      api.createRecord('5ffd0e9e', component.options)
    } else {
      api.reload('5ffd0e9e', component.options)
    }
    module.hot.accept("./SaleEditRowExtraInfoFieldsSettings.vue?vue&type=template&id=5ffd0e9e&scoped=true", function () {
      api.rerender('5ffd0e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/SaleEditRowExtraInfoFieldsSettings.vue"
export default component.exports